import { makeStyle } from '../../../../utils';
import { blackOutline, subTitle1, black, blackHigh, h6, subTitle2, blackMedium } from '../../../../resources/styles';

const styles = {};

styles['container'] = makeStyle({
    padding: 24,
    backgroundColor: 'white',
    display: 'flex',
    flexDirection: 'column',
}, { padding: 48 }, { padding: 36 });

styles['heading'] = makeStyle({ ...h6, letterSpacing: '-0.35px' });

styles['accordion_container'] = makeStyle({
    marginTop: 16,
    alignSelf: 'stretch',
    border: `1px solid ${blackOutline.color}`,
    borderRadius: 4,
});

styles['accordion_header'] = makeStyle({
    display: 'flex',
    padding: 16,
    cursor: 'pointer',
});

styles['accordion_title'] = makeStyle({
    flex: 1,
    ...subTitle1, ...black,
});

styles['accordion_arrow'] = makeStyle({
    color: blackHigh.color,
    marginLeft: 16,
    transition: 'transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)',
});

styles['rotated'] = makeStyle({ transform: 'rotateZ(180deg)' });

styles['accordion_content'] = makeStyle({
    padding: 16,
    borderTop: `1px solid ${blackOutline.color}`,
    ...subTitle2, ...blackMedium,
    textAlign: 'justify',
});

styles['accordion_font'] = makeStyle({...subTitle2, ...blackMedium})

export default styles;